export default {
  /**
   * КТЗ (перший шаг форми)
   */

  e_vin_code: {
    title: 'VIN-код',
    text: 'Унікальний ідентифікаційний номер транспортного засобу, що складається з комбінації цифрових та літерних ' +
      'умовних позначень. VIN-код вказаний у паспорті транспортного засобу. Окрім того, ідентифікаційний номер ' +
      'розташовується на нероз\'ємних складових кузова або шасі та на спеціально виготовлених номерних табличках ' +
      '(шильдиках). Частіше за все, VIN-код складається з 17-ти символів, окрім випадків, коли проводилась його заміна' +
      ' або КТЗ розробили індивідуально.'
  },
  e_vehicle_type: {
    title: 'Тип транспорту',
    text: 'Під типом транспортного засобу розуміється характеристика автомобіля, яка визначається його конструкторськими' +
      ' особливостями і призначенням. Тип транспорту зазначений в реєстраційному свідоцтві, виданому власнику' +
      ' транспортного засобу відповідними  органами ДАІ МВС України.',
  },
  e_vehicle_condition: {
    title: 'Стан',
    text: 'Новим транспортним засобом вважається КТЗ, який жодного разу не був зареєстрований з метою одержання дозволу' +
      ' на його експлуатацію в уповноважених державних органах (у тому числі у країні - експортері КТЗ). У випадках,' +
      ' коли транспортний засіб вже раніше мав реєстрацію, потрібно обирати стан "Б/В".',
  },
  e_production_year: {
    title: 'Рік виробництва',
    text: 'За рік виготовлення КТЗ приймається календарна дата його виготовлення з обов\'язковим зазначенням при' +
      ' цьому дня та місяця цього року. Якщо календарну дату виготовлення визначити неможливо, то за основу береться' +
      ' модельний рік виготовлення, визначений за його VIN-кодом, з урахуванням календарної дати першого' +
      ' документального підтвердження будь-якої дії з даним КТЗ. У разі відсутності даних про календарну дату першого' +
      ' документального підтвердження будь-якої дії з даним КТЗ або виникнення сумнівів щодо її достовірності, коли' +
      ' встановлений модельний рік виготовлення КТЗ збігається з роком виготовлення, зазначеним у свідоцтві про' +
      ' реєстрацію, під час оцінки за дату виготовлення береться 1 січня встановленого за VIN-кодом модельного року.',
  },
  e_code_uktzed: {
    title: 'Код УКТЗЕД',
    text: 'Код класифікації товарів для цілей митного оформлення, що здійснюється згідно з вимогами Української' +
      ' класифікації товарів зовнішньоекономічної діяльності (УКТЗЕД). Код призначається автоматично при виборі' +
      ' типу транспортного засобу, згідно з Законом <a href="https://zakon.rada.gov.ua/laws/show/584%D0%B1-18#n3" target="_blank">«Про митний тариф України»</a>.',
  },
  e_vehicle_mark: {
    title: 'Марка',
    text: 'Назва транспортного засобу, інакше - його бренд або торгова марка. Визначити її можна, скориставшись' +
      ' описовою секцією VIN-коду або у свідоцтві про реєстрацію транспортного засобу.',
  },
  e_vehicle_model: {
    title: 'Модель',
    text: 'Умовне позначення моделі (модифікації) транспортного засобу або типу автомобіля (тип кузова), що' +
      ' випускається під певною маркою. Дізнатись модель можна за допомогою VIN-коду або у реєстраційному документі' +
      ' на транспортний засіб.',
  },
  e_vehicle_modification: {
    title: 'Модифікація',
    text: 'Це спеціальна серія певної моделі машини, де змінювались певні функцій шляхом перевстановлення програмного' +
      ' забезпечення або виконання агрегатних змін. Інформацію про модифікацію транспортного засобу можна переглянути' +
      ' в описовій частині VIN-коду (з 4 по 9 символ) або номері кузова.',
  },
  e_vehicle_fuel_type: {
    title: 'Тип палива',
    text: 'Потрібно вказати, яким паливом заправляється транспортний засіб. Данний вид палива можливо дізнатись у' +
      ' свідоцтві про реєстрацію транспортного засобу або в технічній документації КТЗ.',
  },
  e_engine_capacity: {
    title: 'Об\'єм двигуна',
    text: 'Це характеристика двигуна внутрішнього згоряння, що визначається як сумарний об’єм усіх циліндрів двигуна,' +
      ' виражений в літрах або кубічних сантиметрах. Обʼєм двигуна можна визначити у описовій частині VIN-коду або' +
      ' технічному паспорті транспортного засобу.',
  },
  e_vehicle_transmission_type: {
    title: 'Тип трансмісії',
    text: 'Трансмісія (або коробка передач) - сукупність систем автомобіля, які передають імпульс від двигуна до коліс.' +
      ' Інформацію стосовно типу трансмісії транспортного засобу можна переглянути за допомогою VIN-коду, у технічному' +
      ' паспорті транспортного засобу або технічних документах до транспортного засобу.',
  },
  e_engine_euro_rate: {
    title: 'Євро норма',
    text: 'Євро-норми (класи токсичності) встановлюють граничні значення для викиду шкідливих речовин нових' +
      ' автомобілів. Визначити його можна за допомогою документації транспортного засобу завода-виробника,' +
      ' сертифіката відповідності рівню екологічних вимог, маркуванню на транспортному засобі.',
  },
  e_euro_code: {
    title: 'Євро код',
    text: 'Комбінація символів, яка позначає категорію екологічної норми транспортного засобу відповідно до' +
      ' особливостей її конструкції. Визначити його можна за допомогою документації транспортного засобу' +
      ' завода-виробника, сертифіката відповідності рівню екологічних вимог, маркуванню на транспортному засобі,' +
      ' або знаючи характеристики транспортного засобу за допомогою <a href="https://zakon.rada.gov.ua/laws/show/z1586-12/ed20211119#n487" target="_blank">Додатку 2</a>.',
  },
  e_legal_act_for_euro_rate: {
    title: 'Нормативні акти для норми забрудюючих речовин',
    text: 'Для кожного типу пересувних джерел шкідливих викидів, що експлуатуються на території України,' +
      ' встановлюються нормативи вмісту забруднюючих речовин. Потрібно вказати єдині приписи, щодо офіційного' +
      ' затвердження транспортного засобу, щодо викидів забруднюючих речовин. Визначити нормативний акт можна' +
      ' за допомогою <a href="https://zakon.rada.gov.ua/laws/show/z1586-12/ed20211119#n487" target="_blank">Додатку 2</a>.'
  },

  /**
   * Власник/юридична-довірена особа
   */

  e_last_name: {
    title: 'Прізвище',
    text: 'Прізвище власника транспортного засобу, яке вказано у документі, що посвідчують особу.'
  },
  e_first_name: {
    title: 'Ім\'я',
    text: 'Ім\'я власника транспортного засобу, яке вказано у документі, що посвідчують особу.'
  },
  e_middle_name: {
    title: 'По батькові',
    text: 'Ім\'я по батькові власника транспортного засобу, яке вказано у документі, що посвідчують особу.'
  },
  e_date_birth: {
    title: 'Дата народження',
    text: 'Число, місяць та рік народження власника транспортного засобу, які вказані у документі, що посвідчують особу.'
  },
  e_ipn: {
    title: 'РНОКПП (ІПН)',
    text: 'РНОКПП (раніше – ідентифікаційний код чи ІПН) - це реєстраційний номер облікової картки платника податків,' +
      ' який складається з унікального набору цифр та використовується податковою службою для ідентифікації платника.' +
      ' Вказується у паспорті громадянина України або у довідці з номером платника податків.'
  },
  e_no_inn: {
    title: 'Клієнт не має РНОКПП (ІПН)',
    text: 'Фізична особа, яка через свої релігійні та інші переконання, відмовляється від прийняття реєстраційного' +
      ' номера облікової картки платника податків, із засвідченням свого рішення у державних органах. Підтвердження' +
      ' цього є відмітка в паспорті у формі книжечки "Про право здійснювати будь-які платежі за серією та/або номером' +
      ' паспорта" або у паспорті у формі картки "Відмова".'
  },
  e_index: {
    title: 'Індекс',
    text: 'Числова п\'ятизначна комбінація, що вказує місце реєстрації особи. Знайти індекс за місцем реєстрації' +
      ' власника транспортного засобу можна на сайті <a href="https://index.ukrposhta.ua/" target="_blank">"Укрпошти".</a>'
  },

  /**
   * паспорт ID-картка
   */

  e_passport_card_number: {
    title: 'Номер паспорта',
    text: 'Дев\'ятизначний номер, що вказаний на лицьовій стороні посвідчення особи у полі "Документ № / Document №".'
  },
  e_passport_card_date_start: {
    title: 'Дата видачі',
    text: 'Дата видачі документа, що посвідчує особу, яка знаходиться на зворотньому боці ID-картки у полі "Дата видачі' +
      ' / Date of issue.'
  },
  e_passport_card_date_end: {
    title: 'Дійсний до',
    text: 'Дата закінчення строку дії документа, що вказана на лицьовій стороні ID-картки у полі "Дійсний до /' +
      ' Date of expiry".'
  },
  e_passport_card_region: {
    title: 'Область',
    text: 'Адміністративно-територіальна одиниця України, за якою зареєстрований власник КТЗ. Інформація заповнюється' +
      ' за місцем реєстрації людини, що вказано у довідці про місце реєстрації клієнта або у витягу з реєстру.'
  },
  e_passport_card_city: {
    title: 'Місто/Село',
    text: 'Населений пункт, в якому зареєстрований власник транспортного засобу. Інформація заповнюється за місцем' +
      ' реєстрації людини, що вказано у довідці про місце реєстрації клієнта або у витягу з реєстру.'
  },
  e_passport_card_street: {
    title: 'Вулиця',
    text: 'Назва вулиці, за якою зареєстровано клієнта. Інформація заповнюється за місцем реєстрації особи, що вказано' +
      ' у довідці про місце реєстрації клієнта або у витягу з реєстру.'
  },
  e_passport_card_house: {
    title: 'Дім',
    text: 'Номер житлового будинку або корпусу, за яким зареєстровано клієнта. Інформація заповнюється за місцем' +
      ' реєстрації клієнта, що вказано у довідці про місце реєстрації клієнта або у витягу з реєстру.'
  },
  e_passport_card_flat: {
    title: 'Квартира',
    text: 'Номер квартири, за яким зареєстровано клієнта. Інформація заповнюється за місцем реєстрації особи,' +
      ' що вказано у довідці про місце реєстрації клієнта або у витягу з реєстру.'
  },

  /**
   * Паспорт книжка
   */

  e_passport_book_number: {
    title: 'Серія та номер паспорта',
    text: 'Унікальні ідентифікатор посвідчення громадянина України. Знаходиться у правій верхній частині обкладинки з' +
      ' першої по тридцять другу сторінку, позначені відповідно двома літерами та шістьма цифрами.'
  },
  e_passport_book_date_start: {
    title: 'Дата видачі',
    text: 'Дата видачі паспорта громадянина, що знаходиться на другій сторінці паспорта клієнта.'
  },
  e_passport_book_region: {
    title: 'Область',
    text: 'Адміністративно-територіальна одиниця України, за якою зареєстрований клієнт. Інформація заповнюється' +
      ' за місцем реєстрації особи, що вказана у довідці про місце реєстрації клієнта або у витягу з реєстру.'
  },
  e_passport_book_city: {
    title: 'Місто/Село',
    text: 'Населений пункт, в якому зареєстрований клієнт. Інформація заповнюється за місцем реєстрації людини, що' +
      ' вказана в паспорті у формі книжечки або довідці про місце реєстрації клієнта.'
  },
  e_passport_book_street: {
    title: 'Вулиця',
    text: 'Назва вулиці, за якою зареєстровано клієнта. Інформація заповнюється за місцем реєстрації особи, що вказана' +
      ' в паспорті у формі книжечки або довідці про місце реєстрації клієнта.'
  },
  e_passport_book_house: {
    title: 'Дім',
    text: 'Номер житлового будинку або корпусу, за яким зареєстровано клієнта. Інформація заповнюється за місцем' +
      ' реєстрації клієнта, що вказана в паспорті у формі книжечки або довідці про місце реєстрації клієнта.'
  },
  e_passport_book_flat: {
    title: 'Квартира',
    text: 'Номер квартири, за яким зареєстровано клієнта. Інформація заповнюється за місцем реєстрації особи,' +
      ' що вказана в паспорті у формі книжечки або довідці про місце реєстрації клієнта.'
  },

  e_email: {
    title: 'Email',
    text: 'Актуальна персональная електронна пошта власника транспортного засобу, на яку будуть відправлені документи' +
      ' про проходження сертифікації і власне сертифікат.'
  },
  e_phone: {
    title: 'Номер телефону',
    text: 'Актуальний особистий номер телефону власника транспортного засобу, який використовується для зв\'язку у' +
      ' разі виникнення додаткових питань або екстренних ситуацій.'
  },

  /**
   * Юридична особа, довірена особа
   */
  e_confidant_title: {
    title: 'Довірена особа',
    text: 'Це особа, що має відповідні документи та оригінал доручення на представництво юридичної особи в органах' +
      ' сертифікації та випробувальних лабораторіях.'
  },
  e_organization_name: {
    title: 'Назва',
    text: 'Назва організації, яку представляє клієнт. Інформацію про назву можна знайти в посвідченні відповідальної' +
      ' особи (клієнта).'
  },
  e_organization_norm: {
    title: 'Організаційна форма',
    text: 'Форма діяльності юридичної особи. Знайти відповідну форму можна в установчих документах(рішення про' +
      ' утворення юридичної особи, засновницький договір, статут, положення, установчий акт, установчий договір тощо).'
  },
  e_organization_edrpou: {
    title: 'Код ЄДРПОУ',
    text: 'Унікальний ідентифікаційний номер юридичної особи в Єдиному державному реєстрі підприємств та організацій' +
      ' України. Знайти код можна у відповідному свідоцтві ЄДРПОУ, що видано клієнту.'
  },
  e_organization_index: {
    title: 'Індекс',
    text: 'Числова п\'ятизначна комбінація, що вказує місце реєстрації даної юридичної особи. Знайти індекс за місцем' +
      ' реєстрації клієнта можна на сайті "Укрпошти".'
  },
  e_organization_region: {
    title: 'Область',
    text: 'Адміністративно-територіальна одиниця України, за якою зареєстровано юридичну особу. Інформація заповнюється' +
      ' за місцезнаходженням юридичної особи, що вказано у статуті або в Єдиному державному реєстрі підприємств та' +
      ' організацій України.'
  },
  e_organization_city: {
    title: 'Місто/Село',
    text: 'Населений пункт, в якому зареєстровано юридичну особу. Інформація заповнюється за місцезнаходженням' +
      ' юридичної особи, що вказано у статуті або в Єдиному державному реєстрі підприємств та організацій України.'
  },
  e_organization_street: {
    title: 'Вулиця',
    text: 'Назва вулиці, за якою зареєстровано юридичну особу. Інформація заповнюється за місцем реєстрації особи,' +
      ' що вказано у статуті або в Єдиному державному реєстрі підприємств та організацій України.'
  },
  e_organization_house: {
    title: 'Дім',
    text: 'Номер будинку або корпусу, за яким зареєстровано юридичну особу. Інформація заповнюється за місцем' +
      ' реєстрації клієнта, що вказано у статуті або в Єдиному державному реєстрі підприємств та організацій України.'
  },
  e_organization_flat: {
    title: 'Квартира/Приміщення',
    text: 'Номер квартири, офіса або приміщення, за яким зареєстровано юридичну особу. Інформація заповнюється за' +
      ' місцем реєстрації особи, що вказано у статуті або в Єдиному державному реєстрі підприємств та організацій України.'
  },

  e_organization_last_name: {
    title: 'Прізвище',
    text: 'Прізвище уповноваженої особи, яка має відповідне право на представництво юридичної особи - власниці' +
      ' транспортного засобу. Прізвище вказано у документі, що посвідчує особу.'
  },
  e_organization_first_name: {
    title: 'Ім\'я',
    text: 'Ім\'я уповноваженої особи, яка має відповідне право на представництво юридичної особи - власника' +
      ' транспортного засобу. Ім\'я вказано у документі, що посвідчують особу.'
  },
  e_organization_middle_name: {
    title: 'По батькові',
    text: 'Ім\'я по батькові уповноваженої особи, яка має відповідне право на представництво юридичної особи - власника' +
      ' транспортного засобу. Ім\'я по батькові вказано у документі, що посвідчують особу.'
  },
  e_organization_email: {
    title: 'Email',
    text: 'Актуальна персональна електронна пошта довіреної особи, на яку будуть відправлені документи про проходження' +
      ' сертифікації і власне сертифікат.'
  },
  e_organization_phone: {
    title: 'Номер телефону',
    text: 'Актуальний особистий номер телефону довіреної особи, який використовується для зв\'язку у разі виникнення' +
      ' додаткових питань або екстренних ситуацій.'
  },

  /**
   *
   */

  e_media_passport: {
    title: 'Паспорт',
    text: '<b>Паспорт-книжка:</b> завантажте заповнені 1-6 сторінки паспорту та сторінку з останнім місцем реєстраіції' +
      ' проживання.<br /><b>ID картка:</b> завантажте обидві сторони та довідку про місце реєстрації клієнта ' +
      '(або витяг з реєстру).'
  },
  e_media_ipn: {
    title: 'РНОКПП (ІПН)',
    text: 'Завантажте довідку про присвоєння реєстраційного номера облікової картки платника податків або зворотний' +
      ' бік ID-картки, якщо на ній вказано РНОКПП.'
  },
  e_media_custom_document: {
    title: 'Митні документи',
    text: 'Завантажте документи, що підтверджують правомірність ввезення КТЗ на територію України та митного' +
      ' оформлення транспортного засобу.'
  },
  e_media_registration_certificate: {
    title: 'Свідоцтво про реєстрацію',
    text: 'Завантажте обідви сторони свідоцтва про реєстрацію транспортного засобу.'
  },
  e_media_invoice_copy: {
    title: 'Копія інвойсу',
    text: 'Завантажте фінансовий документ, що підтверджує купівлю транспортного засобу: інвойс, рахунок-фактура,' +
      ' контракт на поставку, договір купівлі-продажу, тощо.'
  },
  e_media_ecological_standard: {
    title: 'Екологічний стандарт',
    text: 'Завантажте сертифікат відповідності щодо індивідуального затвердження транспортного засобу або довідку' +
      ' про екологічний клас, або фото маркування екологічного класу.'
  },
  e_media_power_attorney: {
    title: 'Скан копія довіреності',
    text: 'Завантажте скан копію довіреності на уповноважене представництво власника транспортного засобу фізичною особою.'
  },
  e_media_confirms_identity_person: {
    title: 'Документ, що підтверджує особистість довіреної особи',
    text: 'Завантажте посвідчення особи, що виступає довіреною особою і уповноваженим представником власника' +
      ' транспортного засобу.'
  },
  e_appointment_order_of_manager: {
    title: 'Наказ про призначення керівника',
    text: 'Завантажте фото або сканкопії усіх сторінок наказу про призначення керівника, якщо керівник і директор це ' +
      'різні особи.'
  },
  e_media_documents: {
    title: 'Документи, що підтверджують юридичну особу',
    text: `Правовстановлюючі документи: Довідка платника НДС для ТОВ,
      модельний Статут або витяг з реєстру платників єдиного податку для ФОП.
      <br />Доручення: 1-2х сторінковий документ з реквізитами та документами особи,
      на яку очолюються функції тимчасового представництва`
  },

  e_vehicle_category: {
    title: 'Категорія транспорту',
    text: 'Позначте категорію транспортного засобу відповідно до конструкції та їх технічного стану.<br />' +
      'Категорії колісних транспортних засобів:<br />' +
      '–– категорія L - механічні колісні засоби із двома, трьома або чотирма колесами (мотоколісні засоби);<br />' +
      '–– категорія М - механічні колісні засоби, які мають не менше чотирьох коліс і призначені для перевезення' +
      ' пасажирів та їх багажу;<br />' +
      '–– категорія N - механічні колісні засоби, які мають не менше чотирьох коліс і призначені для перевезення' +
      ' вантажів;<br />' +
      '–– категорія O - причіпні колісні засоби, призначені та сконструйовані для перевезення вантажів або людей,' +
      ' а також для використання як житлові приміщення;<br />' +
      '–– підкатегорія S - для позначення підкатегорії колісних засобів, які належать до підкатегорії колісних засобів' +
      ' спеціального або спеціалізованого призначення;<br />' +
      '–– підкатегорія G - для позначення підкатегорії колісних засобів, які належать до підкатегорії колісних засобів' +
      ' підвищеної прохідності;<br />' +
      '–– підкатегорія GS - для позначення підкатегорії колісних засобів, які належать до підкатегорії колісних' +
      ' засобів спеціального або спеціалізованого призначення підвищеної прохідності.<br />' +
      'З детальною класифікацією відповідно до Постанови №1166 по категоріям і підкатегоріям можна ознайомитись за' +
      ' <a href="https://zakon.rada.gov.ua/laws/show/1166-2010-%D0%BF#Text" target="_blank">посиланням</a>.<br />'
  },

  e_branch_measuring_laboratory: {
    title: 'Філіал вимірювальної лабораторії',
    text: 'Оберіть зі списку найближчий філіал вимірювальної лабораторії, який буде зручно відвідати власнику' +
      ' транспортного засобу.'
  },
  e_measuring_laboratory_requirements: {
    title: 'Вимоги',
    text: 'Вимоги згідно Наказу № 521 з переліком технічних приписів для сертифікації, що доступний за посиланням.'
  },

  /**
  * Реєстрація ОС. Основна інформація
  *
  * */

  e_oc_legal_entity: {
    title: 'Юридична особа',
    text: 'Відповідно до п.п.14.1.213 ст.14 Податкового кодексу України юридична особа резидент – це особи' +
      ' та їх відокремлені особи, які утворені та провадять свою діяльність відповідно до законодавства України з' +
      ' місцезнаходженням як на її території, так і за її межами.'
  },
  e_oc_legal_full_name: {
    title: 'Повна назва організації',
    text: 'Повне найменування юридичної особи повинно містити інформацію про її організаційно-правову форму' +
      ' (крім органів державної влади, органів місцевого самоврядування, органів влади Автономної Республіки Крим,' +
      ' державних, комунальних організацій, закладів, установ) та назву.'
  },
  e_oc_legal_short_name: {
    title: 'Скорочена назва організації',
    text: 'Скорочене найменування організації в реєстраційній картці та в позиції установчих документів' +
      ' "скорочене найменування юридичної особи" повинно мати вигляд - абревіатура організаційно-правової форми' +
      ' юридичної особи "власне ім\'я".'
  },
  e_oc_legal_edrpou: {
    title: 'Код ЄДРПОУ',
    text: '8-значний код-ідентифікатор установи, виданий Державним комітетом статистики України. Знайти його можна' +
      ' у реєстраційних документах установи.'
  },
  e_oc_legal_index: {
    title: 'Індекс',
    text: 'Числова пʼятизначна комбінація, що вказує місце реєстрації органу сертифікації. Знайти індекс за місцем' +
      ' реєстрації установи можна на сайті "Укрпошти".'
  },
  e_oc_legal_region: {
    title: 'Область',
    text: 'Адміністративно-територіальна одиниця України, за якою зареєстровано орган сертифікації.' +
      ' Інформація заповнюється за місцем реєстрації установи, що вказана у довідці про місце реєстрації юридичної' +
      ' особи, у витягу з реєстру або Статуті організації.'
  },
  e_oc_legal_city: {
    title: 'Місто/Село',
    text: 'Населений пункт, в якому зареєстровано орган сертифікації. Інформація заповнюється за місцем реєстрації' +
      ' установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті організації.'
  },
  e_oc_legal_street: {
    title: 'Вулиця',
    text: 'Назва вулиці, за якою зареєстровано орган сертифікації. Інформація заповнюється за місцем реєстрації' +
      ' установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті організації.'
  },
  e_oc_legal_house: {
    title: 'Дім',
    text: 'Номер будинку або корпусу, за яким зареєстровано клієнта. Інформація заповнюється за місцем реєстрації' +
      ' установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті організації.'
  },
  e_oc_legal_flat: {
    title: 'Квартира',
    text: 'Номер квартири, офісу або приміщення, за яким зареєстровано орган сертифікації. Інформація заповнюється' +
      ' за місцем реєстрації установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру' +
      ' або Статуті організації.'
  },
  e_oc_legal_phone: {
    title: 'Номер телефону',
    text: 'Офіційний номер телефону установи, який може бути використаний для зв\'язку у разі виникнення додаткових' +
      ' питань або екстрених ситуацій. Він зазначений в установчих документах юридичної особи.'
  },
  e_oc_legal_added_phone: {
    title: 'Додатковий номер телефону',
    text: 'Вкажіть додатковий номер телефона, якщо такий зазначений в установчих документах юридичної особи.'
  },

  e_oc_certificate_number_NAAU: {
    title: 'Номер атестату акредитації НААУ',
    text: 'Вказати номер Атестату про акредитацію, що виданий Національним агенством з акредитації України.'
  },
  e_oc_certificate_date: {
    title: 'Дата реєстрації атестату акредитації',
    text: 'Вказати дату реєстрації атестату про акредитацію, що виданий Національним агенством з акредитації України.'
  },
  e_oc_certificate_expiration_date: {
    title: 'Термін закінчення дії акредитації',
    text: 'Вказати термін закінчення дії атестату акредитації, що виданий Національним агенством з акредитації України.'
  },
  e_oc_certificate_prefix_info: {
    title: 'Номер призначенний ООВ(Органу з сертифікації) згідно нотифікації ЄК ООН',
    text: 'Вказати номер Органу сертифікації, виданий Міністерством інфраструктури України відповідним наказом під час' +
      ' призначення установі статусу Органу з сертифікації для індивідуального затвердження КТЗ, партій частин та' +
      ' обладнання. Зазначити необхідно числове значення номеру, наприклад: номер "UA.CTR.014" - вписати в поле "014".'
  },
  e_oc_web_resource_prefix_info: {
    title: 'Посилання на веб-ресурс',
    text: 'Введіть повне посилання на веб-ресурс/сайт у повному форматі починаючи з https://... '
  },
  e_oc_order_number_MIU: {
    title: 'Номер наказу яким уповноважено ООВ(Орган з сертифікації)',
    text: 'Зазначити номер Наказу Міністерства інфраструктури України, в якому зазначений даний орган сертифікації' +
      ' як уповноважений на виконання визначених робіт відповідно до наказу Мінінфраструктури від 17.08.12 № 521.'
  },
  e_oc_order_number_MIU_date: {
    title: 'Дата реєстрації Наказу яким уповноважено ООВ(Орган з сертифікації)',
    text: 'Зазначити дату видачі Наказу Міністерства інфраструктури України, в якому зазначений даний орган' +
      ' сертифікації як уповноважений на виконання визначених робіт відповідно до наказу Мінінфраструктури від' +
      ' 17.08.12 № 521.'
  },
  e_oc_categories_list: {
    title: 'Категорії КТЗ',
    text: 'Оберіть всі категорії КТЗ, що входять до сфери призначення Органу сертифікації, що зазначені відповідним' +
      ' наказом Міністерства інфраструктури України під час призначення установі статусу Органу з сертифікації для' +
      ' індивідуального затвердження КТЗ, партій частин та обладнання.'
  },
  e_oc_accounting_branches: {
    title: 'Облік представництв',
    text: 'Вкажіть усі наявні філії вашої організації, якщо такі є.'
  },
  e_oc_branch_address: {
    title: 'Адреса філії',
    text: 'Вказати повну юридичну адресу філії, що вказану у відповідних документах.'
  },
  e_oc_branch_full_name_director: {
    title: 'Прізвище ім\'я по-батькові',
    text: 'Вказати повне ПІБ директора філії.'
  },
  e_oc_branch_email: {
    title: 'Email',
    text: 'Вказати контактну електронну адресу філії, що вказана у відповідних документах.'
  },
  e_oc_branch_phone: {
    title: 'Номер телефону',
    text: 'Вказати номер телефону філії, що вказаний у відповідних документах.'
  },
  e_oc_docs_edrpou: {
    title: 'Витяг з реєстру ЄДРПОУ',
    text: 'Завантажте фото або сканкопію витягу з Єдиного державного реєстру юридичних осіб та фізичних осіб-підприємців.'
  },
  e_oc_docs_number_NAAU: {
    title: 'Атестат про акредитацію НААУ',
    text: 'Завантажте фото або сканкопії усіх сторінок Атестату про акредитацію, виданого Національним агентством з' +
      ' акредитації України.'
  },
  e_oc_docs_spheres_accreditation: {
    title: 'Проект "Сфери акредитації"',
    text: 'Завантажте фото або сканкопії усіх сторінок Додатку до атестата про акредитацію із зазначеними сферами' +
      ' акредитації діяльності установи.'
  },
  e_oc_docs_MIU_order: {
    title: 'Наказ МІУ',
    text: 'Завантажте фото або сканкопії усіх сторінок наказу Міністерства інфраструктури України, в якому зазначений' +
      ' даний орган сертифікації як уповноважений на виконання визначених робіт відповідно до наказу Мінінфраструктури' +
      ' від 17.08.12 № 521.'
  },
  /* ОС Співробітники */
  e_oc_user_last_name: {
    title: 'Прізвище',
    text: 'Вказати прізвище працівника, який працює на підприємстві.'
  },
  e_oc_user_first_name: {
    title: 'Ім\'я',
    text: 'Вказати ім\'я працівника, який працює на підприємстві.'
  },
  e_oc_user_middle_name: {
    title: 'По батькові',
    text: 'Вказати по батькові працівника, який працює на підприємстві.'
  },
  e_oc_user_passport: {
    title: 'Номер паспорта',
    text: 'Вказати номер (серію і номер для паспорта-книжечки) паспорта працівника, який працює на підприємстві.'
  },
  e_oc_user_ipn: {
    title: 'РНОКПП (ІПН)',
    text: 'Вказати реєстраційний номер облікової картки платника податків працівника, який працює на підприємстві.'
  },
  e_oc_user_position: {
    title: 'Займана посада в органі з оцінки відповідності',
    text: 'Вказати посаду працівника, що зазначена у Статуті організації.'
  },
  e_oc_user_email: {
    title: 'Email',
    text: 'Вказати робочий email співробітника, на який буде зареєстровано обліковий запис для роботи в системі' +
      ' "Інфотранс сервіс".'
  },
  e_oc_user_password: {
    title: 'Пароль',
    text: 'Задати пароль для доступу в обліковий запис співробітника для роботи в системі "Інфотранс сервіс"'
  },
  e_oc_user_education: {
    title: 'Документ, що підтверджує здобуття вищої освіти (серія, номер)',
    text: 'Вказати серію і номер документа про здобуття вищої освіти співробітником.'
  },
  e_oc_user_education_date: {
    title: 'Дата видачі документу, що підтверджує здобуття вищої освіти',
    text: 'Вказати дату видачі документа про здобуття вищої освіти співробітником.'
  },
  e_oc_user_education_name: {
    title: 'Найменування навчального закладу',
    text: 'Вказати назву вищого навчального закладу, що видав диплом співробітнику.'
  },
  e_oc_user_qualification: {
    title: 'Спеціальність та кваліфікація',
    text: 'Вказати спеціальність і кваліфікацію, яку здобув співробітник у вказаному вищому навчальному закладі.'
  },
  e_oc_user_qualification_direction: {
    title: 'Напрям підвищення кваліфікації',
    text: 'Вказати повну назву напрямку, за яким співробітник отримав підвищення кваліфікації.'
  },
  e_oc_user_qualification_docs: {
    title: 'Документ, отриманий за результатами підвищення кваліфікації (серія, номер)',
    text: 'Вказати серію і номер документа, який отримав співробітник по закінченню курсів підвищення кваліфікації' +
      ' з даного напрямку.'
  },
  e_oc_user_qualification_date: {
    title: 'Дата видачі документа, отриманого за результатами підвищення кваліфікації',
    text: 'Вказати дату видачі документа, який отримав співробітник по закінченню курсів підвищення кваліфікації' +
      ' з даного напрямку.'
  },
  e_oc_user_qualification_experience: {
    title: 'Досвід виконання робіт з оцінки відповідності продукції, років',
    text: 'Вказати загальну кількість років досвіду виконання робіт з оцінки відповідності продукції.'
  },
  /* питання і докумуенти */
  e_oc_insurance_type: {
    title: 'Тип страхування',
    text: 'Вибрати тип страхування, що застосовується у вашому органі з сертифікації.'
  },
  e_oc_sum_insurance_fund: {
    title: 'Сума страхового фонду (грн)',
    text: 'Вказати суму страхового фонду вашого органу з сертифікації.'
  },
  e_oc_number_insurance_contract: {
    title: 'Номер договору страхування відповідності',
    text: 'Вказати номер договору страхування відповідності вашого органу з сертифікації.'
  },
  e_oc_contract_expiration_date: {
    title: 'Кінцевий строк дії договору',
    text: 'Вказати номер договору страхування відповідності вашого органу з сертифікації.'
  },

  /**
   * Реєстрація ВЛ
   *
   * */

  e_vl_full_name: {
    title: 'Повна назва ВЛ',
    text: 'Повне найменування юридичної особи повинно містити інформацію про її організаційно-правову форму' +
      ' (крім органів державної влади, органів місцевого самоврядування, органів влади Автономної Республіки Крим,' +
      ' державних, комунальних організацій, закладів, установ) та назву.'
  },
  e_vl_short_name: {
    title: 'Скорочена назва ВЛ',
    text: 'Скорочене найменування організації в реєстраційній картці та в позиції установчих документів "скорочене' +
      ' найменування юридичної особи" повинно мати вигляд - абревіатура організаційно-правової форми юридичної особи' +
      ' "власне ім\'я".'
  },
  e_vl_edrpou: {
    title: 'Код ЄДРПОУ',
    text: '8-значний код-ідентифікатор установи, виданий Державним комітетом статистики України. Знайти його можна' +
      ' у реєстраційних документах установи.'
  },
  e_vl_legal_index: {
    title: 'Індекс',
    text: 'Числова пʼятизначна комбінація, що вказує місце реєстрації випробувальної лабораторії. Знайти індекс за місцем' +
      ' реєстрації установи можна на сайті "Укрпошти".'
  },
  e_vl_legal_region: {
    title: 'Область',
    text: 'Адміністративно-територіальна одиниця України, за якою зареєстровано випробувальна лабораторія.' +
      ' Інформація заповнюється за місцем реєстрації установи, що вказана у довідці про місце реєстрації юридичної' +
      ' особи, у витягу з реєстру або Статуті організації.'
  },
  e_vl_legal_city: {
    title: 'Місто/Село',
    text: 'Населений пункт, в якому зареєстровано випробувальна лабораторія. Інформація заповнюється за місцем реєстрації' +
      ' установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті організації.'
  },
  e_vl_legal_street: {
    title: 'Вулиця',
    text: 'Назва вулиці, за якою зареєстровано випробувальна лабораторія. Інформація заповнюється за місцем реєстрації' +
      ' установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті організації.'
  },
  e_vl_legal_house: {
    title: 'Дім',
    text: 'Номер будинку або корпусу, за яким зареєстровано клієнта. Інформація заповнюється за місцем реєстрації' +
      ' установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті організації.'
  },
  e_vl_legal_flat: {
    title: 'Квартира',
    text: 'Номер квартири, офісу або приміщення, за яким зареєстровано випробувальна лабораторія. Інформація заповнюється' +
      ' за місцем реєстрації установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру' +
      ' або Статуті організації.'
  },
  e_vl_NAAU_accreditation_certificate_number: {
    title: 'Номер атестату акредитації НААУ',
    text: 'Вказати номер Атестату про акредитацію, що виданий Національним агенством з акредитації України.'
  },
  e_vl_accreditation_expiration_date: {
    title: 'Термін закінчення дії акредитації',
    text: 'Вказати термін закінчення дії атестату акредитації, що виданий Національним агенством з акредитації України.'
  },
  e_vl_docs_edrpou: {
    title: 'Витяг з реєстру ЄДРПОУ',
    text: 'Завантажте фото або сканкопію витягу з Єдиного державного реєстру юридичних осіб та фізичних осіб-підприємців.'
  },
  e_vl_docs_passport: {
    title: 'Паспорт ВЛ',
    text: 'Завантажте фото або сканкопії усіх сторінок Паспорту випробувальної лабораторії.'
  },
  e_vl_docs_accreditation_certificate: {
    title: 'Атестат про акредитацію НААУ',
    text: 'Завантажте фото або сканкопії усіх сторінок Атестату про акредитацію, виданого Національним агентством' +
      ' з акредитації України.'
  },
  e_vl_docs_sphere_accreditation: {
    title: 'Сфери акредитації ВЛ',
    text: 'Завантажте фото або сканкопії усіх сторінок Додатку до атестату акредитації, де вказані сфери акредитації' +
      ' вашої випробувальної лабораторії.'
  },
  e_vl_docs_legal: {
    title: 'Правовстановлюючі документи',
    text: 'Завантажте фото або сканкопії усіх правовстановлюючих документів установи, наприклад: Статут організації,' +
      ' витяг ЄДРПОУ, банківські реквізити, накази про призначення, договір-довіреність та інші.'
  },
  /* Філії ВЛ */
  e_vl_branch_number: {
    title: 'Номер дільниці',
    text: 'Вказати номер дільниці філії, що зазначений у Сферах акредитації випробувальної лабораторії.'
  },
  e_vl_branch_region: {
    title: 'Область',
    text: 'Адміністративно-територіальна одиниця України, за якою зареєстровано філію випробувальної лабораторії.' +
      ' Інформація заповнюється за місцем реєстрації установи, що вказана у довідці про місце реєстрації юридичної особи,' +
      ' у витягу з реєстру або Статуті організації.'
  },
  e_vl_branch_city: {
    title: 'Місто/Село',
    text: 'Населений пункт, в якому зареєстровано випробувальна лабораторія. Інформація заповнюється за місцем' +
      ' реєстрації установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті' +
      ' організації.'
  },
  e_vl_branch_street: {
    title: 'Вулиця',
    text: 'Назва вулиці, за якою зареєстровано випробувальна лабораторія. Інформація заповнюється за місцем реєстрації' +
      ' установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті організації.'
  },
  e_vl_branch_house: {
    title: 'Дім',
    text: 'Номер будинку або корпусу, за яким зареєстровано клієнта. Інформація заповнюється за місцем реєстрації' +
      ' установи, що вказано у довідці про місце реєстрації юридичної особи, у витягу з реєстру або Статуті організації.'
  },
  e_vl_branch_flat: {
    title: 'Квартира',
    text: 'Номер квартири, офісу або приміщення, за яким зареєстровано випробувальна лабораторія.' +
      ' Інформація заповнюється за місцем реєстрації установи, що вказано у довідці про місце реєстрації юридичної' +
      ' особи, у витягу з реєстру або Статуті організації.'
  },
  e_vl_branch_index: {
    title: 'Індекс',
    text: 'Числова п\'ятизначна комбінація, що вказує місце реєстрації випробувальної лабораторії.' +
      ' Знайти індекс за місцем реєстрації установи можна на сайті "Укрпошти".'
  },
  e_vl_branch_line: {
    title: 'Кількість випробувальних ліній',
    text: 'Вказати загальну кількість випробувальних ліній даної філії, що зазначена у Сферах акредитації' +
      ' випробувальної лабораторії.'
  },
  e_vl_branch_categories: {
    title: 'Категорії КТЗ',
    text: `Оберіть категорії КТЗ, що входять до сфери акредитації дільниці Органу з оцінки відповідності.
      Офіційно затвердженні відповідальним органом Національного агентства з акредитації України.`
  },
  /* Співпраця з ОС */
  e_vl_branch_docs_passport: {
    title: 'Паспорт ВЛ',
    text: 'Завантажте фото або сканкопії усіх сторінок Паспорту випробувальної лабораторії даної філії.'
  },
  e_vl_branch_docs_spheres: {
    title: 'Сфери акредитації ВЛ',
    text: 'Завантажте фото або сканкопії усіх сторінок Додатку до атестата про акредитацію із зазначеними сферами' +
      ' акредитації діяльності установи.'
  },
  e_vl_branch_docs_method: {
    title: 'Дані про оцінку методів випробування',
    text: 'Завантажте фото або сканкопії з переліком методик випробування, розроблених лабораторією.'
  },
  e_vl_contract_edrpou: {
    title: 'Код ЄДРПОУ',
    text: '8-значний код-ідентифікатор установи, виданий Державним комітетом статистики України. Знайти його можна' +
      ' у реєстраційних документах установи.'
  },
  e_vl_contract_doc_name: {
    title: 'Назва документу про співпрацю',
    text: 'Вказати назву документа, яким обумовлені умови співпраці з Органом сертифікації.'
  },
  e_vl_contract_date: {
    title: 'Дата укладання договору про співпрацю',
    text: 'Вказати дату укладання договору про співпрацю, що зазначена в цьому договорі.'
  },
  e_vl_contract_expiration_date: {
    title: 'Дата закінчення договору про співпрацю',
    text: 'Вказати дату закінчення договору про співпрацю, що зазначена в цьому договорі.'
  },
  e_vl_contract_docs_contract: {
    title: 'Договір про співпрацю',
    text: 'Завантажте фото або сканкопії усіх сторінок договору про співпрацю з даним Органом сертифікації.'
  },
  /**
   * Trusted Person
   */
  trusted_person: {
    last_name: {
      title: 'Прізвище довіренної особи',
      text: `Прізвище уповноваженої особи, яка має відповідне право на представництво фізичної
        особи - власниці транспортного засобу. Прізвище вказано у документі, що посвідчує особу.`
    },
    first_name: {
      title: 'Імʼя довіренної особи',
      text: `Імʼя уповноваженої особи, яка має відповідне право на представництво фізичної
        особи - власника транспортного засобу. Імʼя вказано у документі, що посвідчують особу.`
    },
    middle_name: {
      title: 'По батькові особи, якій видано довіреність',
      text: `Імʼя по батькові уповноваженої особи, яка має відповідне право на представництво
        фізичної особи - власника транспортного засобу. Імʼя по батькові вказано у документі, що посвідчують особу.`
    },
    date_birth: {
      title: 'Дата народження',
      text: `Число, місяць та рік народження уповноваженої особи, яка має відповідне право на представництво
        фізичної особи - власника транспортного засобу, які вказані у документі, що посвідчують особу.`
    },
    email: {
      title: 'Email',
      text: `Актуальна персональна електронна пошта довіреної особи власника транспортного засобу, на яку
        будуть відправлені документи про проходження сертифікації і власне сертифікат.`
    },
    phone: {
      title: 'Номер телефону',
      text: `Актуальний особистий номер телефону довіреної особи власника транспортного засобу,
        який використовується для зв'язку у разі виникнення додаткових питань або екстрених ситуацій.`
    },
    id_card: {
      serial: {
        title: 'Номер паспорта',
        text: `Девʼятизначний номер, що вказаний на лицьовій стороні посвідчення особи
          у полі "Документ № / Document №".`
      },
      date_start: {
        title: 'Дата видачі',
        text: `Дата видачі документа, що посвідчує особу, яка знаходиться на зворотному боці ID-картки
          у полі "Дата видачі / Date of issue.`
      },
      date_end: {
        title: 'Дата закінчення дії',
        text: `Дата закінчення строку дії документа, що вказана на лицьовій стороні ID-картки
          у полі "Дійсний до / Date of expiry".`
      },
      index: {
        title: 'Індекс',
        text: `Числова пʼятизначна комбінація, що вказує місце реєстрації особи. Знайти індекс за місцем
          реєстрації довіреної особи власника транспортного засобу можна на <a href="https://index.ukrposhta.ua/find-post-index" target="_blank">сайті "Укрпошти"</a>.`
      },
      region: {
        title: 'Область',
        text: `Адміністративно-територіальна одиниця України, за якою зареєстровано довірену особу власника
          транспортного засобу. Інформація заповнюється за місцем реєстрації людини, що вказано у довідці
          про місце реєстрації клієнта або у витягу з реєстру.`
      },
      city: {
        title: 'Місто/Село',
        text: `Населений пункт, в якому зареєстровано довірену особу власника транспортного засобу. Інформація
          заповнюється за місцем реєстрації людини, що вказано у довідці про місце реєстрації клієнта або
          у витягу з реєстру.`
      },
      street: {
        title: 'Вулиця',
        text: `Назва вулиці, за якою зареєстровано довірену особу власника транспортного засобу. Інформація
          заповнюється за місцем реєстрації особи, що вказано у довідці про місце реєстрації клієнта або
          у витягу з реєстру.`
      },
      house: {
        title: 'Дім',
        text: `Номер житлового будинку або корпусу, за яким зареєстровано довірену особу власника транспортного
          засобу. Інформація заповнюється за місцем реєстрації клієнта, що вказано у довідці про місце реєстрації
          клієнта або у витягу з реєстру.`
      },
      flat: {
        title: 'Квартира',
        text: `Номер квартири, за яким зареєстровано довірену особу власника транспортного засобу. Інформація
          заповнюється за місцем реєстрації особи, що вказано у довідці про місце реєстрації клієнта або у витягу з реєстру.`
      }
    },
    paper: {
      serial: {
        title: 'Номер паспорта',
        text: `Унікальні ідентифікатор посвідчення громадянина України. Знаходиться у правій верхній частині
          обкладинки з першої по тридцять другу сторінку, позначені відповідно двома літерами та шістьма цифрами.`
      },
      date_start: {
        title: 'Дата видачі',
        text: `Дата видачі паспорта громадянина, що знаходиться на другій сторінці паспорта клієнта.`
      },
      index: {
        title: 'Індекс',
        text: `Числова пʼятизначна комбінація, що вказує місце реєстрації даної особи. Знайти індекс за місцем
          проживання довіреної особи власника транспортного засобу можна на <a href="https://index.ukrposhta.ua/find-post-index" target="_blank">сайті "Укрпошти"</a>.`
      },
      region: {
        title: 'Область',
        text: `Адміністративно-територіальна одиниця України, за якою зареєстровано довірену особу власника
          транспортного засобу. Інформація заповнюється за місцем реєстрації особи, що вказана у
          довідці про місце реєстрації клієнта або у витягу з реєстру.`
      },
      city: {
        title: 'Місто/Село',
        text: `Населений пункт, в якому зареєстровано довірену особу власника транспортного засобу. Інформація
          заповнюється за місцем реєстрації людини, що вказана в паспорті у формі книжечки або довідці про
          місце реєстрації клієнта.`
      },
      street: {
        title: 'Вулиця',
        text: `Назва вулиці, за якою зареєстровано довірену особу власника транспортного засобу. Інформація
          заповнюється за місцем реєстрації особи, що вказана в паспорті у формі книжечки або довідці про
          місце реєстрації клієнта.`
      },
      house: {
        title: 'Дім',
        text: `Номер житлового будинку або корпусу, за яким зареєстровано довірену особу власника транспортного
          засобу. Інформація заповнюється за місцем реєстрації клієнта, що вказана в паспорті у формі книжечки
          або довідці про місце реєстрації клієнта.`
      },
      flat: {
        title: 'Квартира',
        text: `Номер квартири, за якою зареєстровано довірену особу власника транспортного засобу. Інформація
          заповнюється за місцем реєстрації особи, що вказана в паспорті у формі книжечки або довідці про
          місце реєстрації клієнта.`
      }
    }
  },
  /**
   * International passport
   */
  international_passport: {
    serial: {
      title: 'Номер паспорта',
      text: `Унікальні ідентифікатор, що містить дві латинські літери та шість цифр. Знаходиться
        у правій верхній частині полікарбонатної сторінки паспорту у полі "Номер паспорта / Passport No".`
    },
    date_start: {
      title: 'Дата видачі',
      text: `Дата видачі документа, що посвідчує особу, що знаходиться на полікарбонатній сторінці
        у полі "Дата видачі / Date of issue.`
    },
    date_end: {
      title: 'Дата закінчення дії',
      text: `Дата закінчення дії документа, що вказана на полікарбонатній сторінці
        у полі "Дата закінчення строку дії / Date of expiry".`
    },
    personal_number: {
      title: 'Персональний номер',
      text: `Це цифровий, незмінний ідентифікатор людини, який допомагає встановити особу, представлений
        двома послідовностями з восьми та п’яти цифр, розділених текстовим символом «-» і позначений
        у полі "Запис № / Record No.".`
    },
    issued_department: {
      title: 'Орган що видав',
      text: `Код підрозділу Державної міграційної служби України, що видав документ. Позначається
        послідовністю з чотирьох цифр в полі "Орган, що видав / Authority".`
    }
  },
  /**
   * ОТК
   */
  technical_control: {
    inspection: {
      vin_code: {
        title: 'VIN код',
        text: `Унікальний ідентифікаційний номер транспортного засобу, що складається з комбінації цифрових
          та літерних умовних позначень. VIN-код вказаний у паспорті транспортного засобу.
          Окрім того, ідентифікаційний номер розташовується на нероз'ємних складових кузова або шасі та на
          спеціально виготовлених номерних табличках (шильдиках). Частіше за все, VIN-код складається з 17-ти
          символів, окрім випадків, коли проводилась його заміна або КТЗ розробили індивідуально.`
      },
      vehicle_category: {
        title: 'Категорія КТЗ',
        text: `Позначте категорію транспортного засобу відповідно до конструкції та їх технічного стану.<br />
          Категорії колісних транспортних засобів:<br />
          –– категорія L - механічні колісні засоби із двома, трьома або чотирма колесами (мотоколісні засоби);<br />
          –– категорія М - механічні колісні засоби, які мають не менше чотирьох коліс і призначені для перевезення пасажирів
            та їх багажу;<br />
          –– категорія N - механічні колісні засоби, які мають не менше чотирьох коліс і призначені для
            перевезення вантажів;<br />
          –– категорія O - причіпні колісні засоби, призначені та сконструйовані для перевезення вантажів або людей,
            а також для використання як житлові приміщення;<br />
          –– підкатегорія S - для позначення підкатегорії колісних засобів, які належать до підкатегорії колісних засобів
            спеціального або спеціалізованого призначення;<br />
          –– підкатегорія G - для позначення підкатегорії колісних засобів, які належать до підкатегорії колісних засобів
            підвищеної прохідності;<br />
          –– підкатегорія GS - для позначення підкатегорії колісних засобів, які належать до підкатегорії колісних засобів
            спеціального або спеціалізованого призначення підвищеної прохідності.<br />
          З детальною класифікацією відповідно до Постанови №1166 по категоріям і підкатегоріям
            можна ознайомитись за <a href="https://zakon.rada.gov.ua/laws/show/1166-2010-%D0%BF#Text" target="_blank">посиланням</a>.`
      },
      special_purpose: {
        title: 'Спеціальне призначення КТЗ',
        text: `До них належить транспортні засоби категорій M, N чи O для перевезень пасажирів або вантажів та для виконання
          спеціальних функцій, для яких необхідний спеціальний кузов чи спеціальне обладнання. Вкажіть, за наявності,
          спеціальне призначення транспортного засобу.`
      },
      vehicle_mark: {
        title: 'Марка',
        text: `Назва транспортного засобу, інакше - його бренд або торгова марка. Визначити її можна, скориставшись
          описовою секцією VIN-коду або у свідоцтві про реєстрацію транспортного засобу.`
      },
      vehicle_model: {
        title: 'Модель',
        text: `Умовне позначення моделі (модифікації) транспортного засобу або типу автомобіля (тип кузова),
          що випускається під певною маркою. Дізнатись модель можна за допомогою VIN-коду або у
          реєстраційному документі на транспортний засіб.`
      },
      vehicle_color: {
        title: 'Колір',
        text: `Актуальний колір транспортного засобу, що може не співпадати із заявленим заводом-виробником.
          Визначити колір кузова можна за даними із технічної документації КТЗ, у свідоцтві про реєстрацію або
          за VIN-кодом (за умови, якщо транспортний засіб має заводський колір кузова) або органолептичним
          контролем (візуальним оглядом та на дотик).`
      },
      load_capacity: {
        title: 'Вантажопідйомність',
        text: `Це різниця між максимальною масою транспортного засобу (повною масою транспортного засобу)
          та спорядженою масою транспортного засобу, яка дорівнює масі вантажу, який можна завантажити та
          перевозити на транспортному засобі. Вона вказана в технічній документації КТЗ.`
      },
      registration_number: {
        title: 'Державний реєстраційний номер',
        text: `Унікальний номер, що було надано територіальними органами з надання сервісних послуг МВС
          при первинній реєстрації КТЗ. Номер вказано у Свідоцтві про реєстрацію транспортного засобу.`
      },
      vehicle_mileage: {
        title: 'Показник одометра',
        text: `Числове значення пробігу КТЗ, тобто відстані, яку він здолав під час експлуатації.
          Знайти його можна на приборній панелі КТЗ.`
      },
      previous_vehicle_mileage: {
        title: 'Попередній показник одометра',
        text: `Вказати показник одометра, що був зафіксований при попередньому обовʼязковому
          технічному контролі або сертифікації.`
      },
      fuel_type: {
        title: 'Тип палива',
        text: `Потрібно вказати, яким паливом заправляється транспортний засіб. Даний вид палива можливо
          дізнатись у свідоцтві про реєстрацію транспортного засобу або в технічній документації КТЗ.`
      },
      has_turbine_or_compressor: {
        title: 'Наявність турбіни чи компресора',
        text: `Вказати наявність пристроїв для збільшення потужності моторі транспортного засобу.
          Визначити їх можна в технічній документації КТЗ.`
      },
      count_cylinders: {
        title: 'Кількість циліндрів',
        text: `Кількість циліндрів двигуна автомобіля. Визначити розташування можна з технічної
          документації транспортного засобу.`
      },
      engine_euro_rate: {
        title: 'Екологічний рівень',
        text: `Євро-норми (класи токсичності) встановлюють граничні значення для викиду шкідливих
          речовин нових автомобілів. Визначити його можна за допомогою документації транспортного засобу
          завода-виробника, сертифіката відповідності рівню екологічних вимог, маркуванню на транспортному засобі.`
      },
      production_year: {
        title: 'Дата виготовлення',
        text: `За рік виготовлення КТЗ приймається календарна дата його виготовлення з обов'язковим зазначенням
          при цьому дня та місяця цього року. Якщо календарну дату виготовлення визначити неможливо, то за основу
          береться модельний рік виготовлення, визначений за його VIN-кодом, з урахуванням календарної дати першого
          документального підтвердження будь-якої дії з даним КТЗ. У разі відсутності даних про календарну дату першого
          документального підтвердження будь-якої дії з даним КТЗ або виникнення сумнівів щодо її достовірності,
          коли встановлений модельний рік виготовлення КТЗ збігається з роком виготовлення, зазначеним у свідоцтві про
          реєстрацію, під час оцінки за дату виготовлення береться 1 січня встановленого за VIN-кодом модельного року.`
      },
      first_registration_date: {
        title: 'Дата першої реєстрації',
        text: `Дата реєстрації транспортного засобу, яка здійснюється уповноваженими державними органами України щодо
          цього транспортного засобу в Україні вперше. Визначити її можна у Свідоцтві про реєстрацію транспортного засобу.`
      },
      government_registration_date: {
        title: 'Дата державної реєстрації',
        text: `Вказати дату реєстрації транспортного засобу, що проводиться територіальними органами з
          надання сервісних послуг МВС.`
      },
      conversion: {
        name_document: {
          title: 'Назва документу',
          text: 'Вказати тип переобладнення, що зазначено у документі.'
        },
        date: {
          title: 'Дата',
          text: 'Вказати дату проведення переобладнання транспортного засобу, що вказана у документі.'
        },
        number_document: {
          title: 'Номер документу',
          text: 'Вказати номер документу про переобладнання транспортного засобу, що вказаний у документі.'
        },
        description: {
          title: 'Суть переобладнання',
          text: 'Описати, які зміни були внесені в попередню конструкцію транспортного засобу.'
        }
      },
      countAxles: {
        title: 'Кількість осей',
        text: `Вісь -  центральний стрижень для обертання колеса чи шестерні. Визначити кількість
          осей транспортного засобу можна органолептичним контролем (візуальним оглядом та на дотик),
          з технічної документації на автомобіль, у сертифікаті відповідності або за VIN-кодом.
        `
      },
      equippedWeight: {
        title: 'Маса КТЗ у спорядженому стані',
        text: `Це маса транспортного засобу, яка враховує вагу стандартного обладнання (запасного колеса, інструментів),
          масу усіх експлуатаційних матеріалів (палива, рідини, що охолоджує, масла і т. д.), але не враховує масу вантажу,
          водія і пасажирів. Виміряти можна лабораторним методом або дізнатись з технічної документації транспортного засобу.
		    `
      },
      enginePower: {
        title: 'Максимальна потужність',
        text: `Максимальна потужність двигуна виражає відношення роботи механізму до часового інтервалу її здійснення.
          Дізнатись її можна з технічної документації транспортного засобу.
        `
      },
      exceptionCodes: {
        title: 'Коди невідповідності',
        text: `Код невідповідності технічного стану ТЗ - комбінація цифрових знаків, що застосовуються для відображення,
          передачі, статистичного оброблення та зберігання інформації про виявлену невідповідність технічного стану транспортного засобу.<br />
          Вказати код невідповідності:<br />
          - 001.010 - якщо дані у свідоцтві про державну реєстрацію транспортного засобу не відповідають даним ідентифікації транспортного засобу;<br />
          - 915.021 - якщо показник одометра менший, ніж показник одометра, зафіксований під час попереднього обов’язкового технічного контролю,
          проведеного суб’єктом здійснення обов’язкового технічного контролю, або реєстраційних операцій.
        `
      },
      isNeededDetailInspection: {
        title: 'Додаток 8 "Перевірка сили світла ПЗС"',
        text: `Перевірка сили світла ПЗС призначається за потреби, наприклад, за відсутності знака офіційного затвердження, виникнення спірних
          питань щодо потужності джерел світла або нанесення покриву на ПЗС тощо. Результати перевірки відображаються у Додатку 8 відповідного протокола.
		    `
      }
    }
  },
  /**
   * Огляд фар
   */
  inspection_headlights: {
    headlight: {
      title: 'Фара',
      text: 'Виберіть тип фари в конструкції транспортного засобу.'
    },
    color: {
      title: 'Колір',
      text: 'Виберіть колір встановлених вогнів автомобіля.'
    },
    marking_duplicate: {
      title: 'Маркування відрізняється',
      text: 'Якщо в парі фар відбулась заміна однієї з них, маркування буде відрізнятись.'
    },
    serial: {
      title: 'Маркування',
      text: 'Вказати маркування відповідно до міжнародно затвердженого зразку, наприклад: E5 R01216, або E11 2291.'
    },
    exceptionCodes: {
      title: 'Коди невідповідності',
      text: `"Код невідповідності технічного стану ТЗ - комбінація цифрових знаків, що застосовуються для відображення,
        передачі, статистичного оброблення та зберігання інформації про виявлену невідповідність технічного стану
        транспортного засобу.<br />
        Вказати код невідповідності:<br />
        - 403.020 - якщо колір світлової дії не відповідає вимогам виробника;<br />
        - 411.900 - якщо наявне самовільне переобладнання зовнішніх світлових приладів."<br />
      `
    }
  },

  /**
   * Картка огляду
   */

  inspection_form: {
    type: {
      title: 'Тип',
      text: `Це сукупність колісних транспортних засобів, які не відрізняються один від одного принаймні за істотними
       ознаками. За наявності вказати додаткові характеристики транспортного засобу, що вказані заводом-виробником:
        у відповідній технічній документації на транспортний засіб, маркувальних документах або попередньому свідоцтві
        про реєстрацію транспортного засобу.`
    },
    variant: {
      title: 'Варіант',
      text: `Це сукупність колісних транспортних засобів, які належать до одного типу і не відрізняються один від
      одного принаймні за істотними характеристиками. За наявності вказати додаткові характеристики транспортного
      засобу, що вказані заводом-виробником: у відповідній технічній документації на транспортний засіб, маркувальних
      документах або попередньому свідоцтві про реєстрацію транспортного засобу.`
    },
    version: {
      title: 'Версія',
      text: `Це сукупність колісних транспортних засобів, які належать до одного типу та варіанта і можуть мати
      зазначені виробником поєднання характеристик параметрів. За наявності вказати додаткові характеристики
      транспортного засобу, що вказані заводом-виробником: у відповідній технічній документації на транспортний засіб,
      маркувальних документах або попередньому свідоцтві про реєстрацію транспортного засобу.`
    },
    brand: {
      title: 'Марка',
      text: `Назва транспортного засобу, інакше - його бренд або торгова марка. Визначити її можна, скориставшись
      описовою секцією VIN-коду або у свідоцтві про реєстрацію транспортного засобу.`
    },
    model: {
      title: 'Модель',
      text: `Умовне позначення моделі (модифікації) транспортного засобу або типу автомобіля (тип кузова), що
      випускається під певною маркою. Дізнатись модель можна за допомогою VIN-коду або у реєстраційному документі на
      транспортний засіб.`
    },
    modification: {
      title: 'Модифікація',
      text: `Це спеціальна серія певної моделі машини, де змінювались певні функцій шляхом перевстановлення програмного
      забезпечення або виконання агрегатних змін. Інформацію про модифікацію транспортного засобу можна переглянути в
      описовій частині VIN-коду (з 4 по 9 символ) або номері кузова.`
    },
    carcass_type: {
      title: 'Тип кузова',
      text: `Позначення зовнішнього вигляду і характеристик транспортного засобу відповідно до Порядку затвердження
      конструкції транспортних засобів, їх частин та обладнання. Визначити тип кузова можна за даними із технічної
      документації на автомобіль, у сертифікаті відповідності або за VIN-кодом.`
    },
    seats_count: {
      title: 'Кількість місць для сидіння (включаючи водія)',
      text: `Визначає дозволену кількість місць для сидіння у транспортному засобі. Визначити їхню кількість можна за
       даними із технічної документації на автомобіль або у сертифікаті відповідності.`
    },
    count_standing_places: {
      title: 'Кількість місць для пасажирів, які стоять',
      text: `Визначає дозволену кількість місць для стояння на майданчику для розташування пасажирів у транспортному
       засобі. Визначити їхню кількість можна за даними із технічної документації на автомобіль або у сертифікаті
       відповідності.`
    },
    country_manufacture: {
      title: 'Країна виробника',
      text: `Країна, що виготовила транспортний засіб. Визначити її можна за даними із технічної документації на
      автомобіль, у сертифікаті відповідності або за VIN-кодом.`
    },
    doors_count: {
      title: 'Кількість дверей',
      text: `Загальна кількість бокових, задніх дверей транспортного засобу. Визначити їхню кількість можна за даними
       із технічної документації на автомобіль або у сертифікаті відповідності.`
    },
    doors_location: {
      title: 'Розташування дверей',
      text: `Особливості конструкції дверей у транспортному засобі. Визначити їхню кількість можна за даними із
      технічної документації на автомобіль або у сертифікаті відповідності.`
    },
    year_production: {
      title: 'Рік виробництва',
      text: `За рік виготовлення КТЗ приймається календарна дата його виготовлення з обов'язковим зазначенням при цьому
       дня та місяця цього року. Якщо календарну дату виготовлення визначити неможливо, то за основу береться модельний
       рік виготовлення, визначений за його VIN-кодом, з урахуванням календарної дати першого документального
       підтвердження будь-якої дії з даним КТЗ. У разі відсутності даних про календарну дату першого документального
       підтвердження будь-якої дії з даним КТЗ або виникнення сумнівів щодо її достовірності, коли встановлений
       модельний рік виготовлення КТЗ збігається з роком виготовлення, зазначеним у свідоцтві про реєстрацію, під час
        оцінки за дату виготовлення береться 1 січня встановленого за VIN-кодом модельного року.`
    },
    color: {
      title: 'Колір',
      text: `Актуальний колір транспортного засобу, що може не співпадати із заявленим заводом-виробником. Визначити
       колір кузова можна за даними із технічної документації на автомобіль, у свідоцтві про реєстрацію або за
       VIN-кодом(за умови, якщо транспортний засіб має заводський колір кузова).`
    },
    location_plates: {
      title: 'Місце розміщення обов\'язкових табличок',
      text: `Вказати місце розміщення спеціальних табличок(шильдів), що містять інформацію про технічні характеристики
      транспортного засобу.`
    },
    location_identification_number: {
      title: 'Розміщення ідентифікаційного номера',
      text: `Вказати місце розміщення ідентифікаційного номера(VIN-коду) транспортного засобу, що вигравіруваний на
      табличці завода-виробника.`
    },
    approval_number: {
      title: 'Номер затвердження або знак затвердження зчіпного пристрою (у разі нанесення)',
      text: `Номер/знак офіційного затвердження, що був нанесений заводом-виробником на корпус зчіпного пристрою
       відповідно до міжнародних вимог. За наявності, визначити його можна за допомогою органолептичного методу
       (органами зору та на дотик) або з технічної документації зчіпного пристрою.`
    },
    vin_code: {
      title: 'VIN-код',
      text: `Унікальний ідентифікаційний номер транспортного засобу, що складається з комбінації цифрових та літерних
       умовних позначень. VIN-код вказаний у паспорті транспортного засобу. Окрім того, ідентифікаційний номер
        розташовується на нероз'ємних складових кузова або шасі та на спеціально виготовлених номерних табличках
        (шильдиках). Частіше за все, VIN-код складається з 17-ти символів, окрім випадків, коли проводилась його
         заміна або КТЗ розробили індивідуально.`
    },
    mileage: {
      title: 'Пробіг',
      text: `Вказує на кількість відстані, яку подолав транспортний засіб під час експлуатації. Дізнатися її можна за
       даними одометру або звірити з даними дилера автомобіля.`
    },
    approval_dangerous_cargo: {
      title: 'Затвердження конструкції щодо перевезення небезпечних вантажів',
      text: `Вказати на наявність у власника транспортного засоба свідоцтва про допущення транспортних засобів до
      перевезення визначених небезпечних вантажів.`
    },
    vehicle_class: {
      title: 'Клас КТЗ',
      text: `Відповідно до Директиви 2001/85/EC транспортні засоби категорій M2 та M3 поділяють на класи в залежності
      від кількості пасажирських сидінь, окрім місця водія:<br><br>
        Кількість сидінь більша, ніж 22:<br>
        - “клас І” — із місцями для сидіння та для стояння і пересування (міські);<br>
        - “клас ІІ” — із місцями для сидіння та для стояння (приміські);<br>
        - “клас ІІІ”  — тільки із місцями для сидіння (міжміські).<br><br>
        Кількість сидінь не перевершує 22:<br>
        - “клас A”  — із місцями для сидіння та для стояння;<br>
        - “клас B”  — тільки із місцями для сидіння.<br><br>
        Визначити клас можна органолептичним контролем (візуальним оглядом та на дотик) або з технічної документації
         транспортного засобу.`
    },

    count_axles: {
      title: 'Кількість осей',
      text: `Вісь -  центральний стрижень для обертання колеса чи шестерні. Дізнатись про кількість осей транспортного
      засобу можна органолептичним контролем(візуальним оглядом та на дотик), з технічної документації на автомобіль,
      у сертифікаті відповідності або за VIN-кодом.`
    },
    count_wheels: {
      title: 'Кількість коліс',
      text: `Колесо - елемент ходової частини, що пов'язує автомобіль з дорогою. Визначити кількість коліс
      транспортного засобу можна органолептичним контролем(візуальним оглядом та на дотик), з технічної документації
      автомобіля, у сертифікаті відповідності або за VIN-кодом.`
    },
    vehicle_drive: {
      title: 'Провідні осі',
      text: `(Ведучі вісі) Вісь транспортного засобу, на яку передається крутний момент двигуна, і колеса якого
      приводять транспортний засіб в рух. Визначити їх можна за технічною документацією транспортного засобу.`
    },
    controlled_axles: {
      title: 'Керовані осі',
      text: `Вісь, що служить для управління напрямом руху транспортного засобу. Визначити їх можна за технічною
      документацією транспортного засобу.`
    },
    count_drive_axles: {
      title: 'Рушійні осі кількість',
      text: `Вказати кількість рушійних осей КТЗ.  Визначити їх можна за технічною документацією транспортного засобу.`
    },
    // steering_type: {
    //   title: 'Тип механізму кермової колонки',
    //   text: `Тип конструкції, де рухи з кермового валу перетворюються з крутного моменту в площинні переміщення.
    //   Визначити його можна за технічною документацією транспортного засобу.`
    // },
    steering_boost_method: {
      title: 'Метод посилення кермового колеса',
      text: `Це підсистема, що складається з механізму, що дозволяє значно знизити зусилля водія при повороті керма
      та керуванні автомобілем. Визначити його можна за допомогою технічної документації транспортного засобу.				`
    },
    count_fuel_tanks: {
      title: 'Кількість паливних баків',
      text: `Кількість резервуарів для зберігання різного виду палива. Визначити їхню кількість можна за технічною
      документацією транспортного засобу.`
    },
    count_silencers: {
      title: 'Кількість глушників',
      text: `Глушник або акустичний фільтр - пристрій, що застосовується в техніці для зниження шуму, який створюють
      відпрацьовані гази двигуна. Визначити кількість можна за допомогою органолептичного методу(візуальним оглядом та
      на дотик) або з технічної документації на транспортний засіб.`
    },
    wheel_formula: {
      title: 'Колісна формула',
      text: `Це умовне позначення загального числа коліс транспортного засобу і числа провідних коліс числами.
      Визначити формулу можна за допомогою органолептичного методу(візуальним оглядом та на дотик) та з технічної
      документації транспортного засобу.`
    },
    steering_wheel_location: {
      title: 'Розташування рульового колеса',
      text: `Рульове колесо - пристрій для керування рухом автомобіля у заданому напрямку. Визначити кількість можна
      за допомогою органолептичного методу(візуальним оглядом та на дотик) або з технічної документації транспортного
      засобу.`
    },
    boot_space_length: {
      title: 'Довжина завантажувального простору',
      text: `Значення максимально дозволеної довжини конструкції, де можна розташувати вантажі. Визначити її можна за
      допомогою органолептичного контролю(візуальним оглядом та на дотик) та з технічної документації транспортного
      засобу.`
    },
    lifting_axles: {
      title: 'Розташування підйомної(их) осі (осей)',
      text: `Підйомна вісь (або "лінивець") - це вісь транспортного засобу/причепу, яка зазвичай не бере участі під
      час руху. Використовується для розвантаження провідної осі та збільшення вантажопідйомності ТЗ. Визначити її
      розташування можна за допомогою органолептичного контролю (візуальним оглядом та на дотик) та з технічної
      документації транспортного засобу.`
    },
    trailer_type_brake_connector: {
      title: 'Тип гальмівних з\'єднувачів причепа',
      text: `Механізм, що забезпечує синхронне гальмування автомобілю і причепа. Визначити її розташування можна за
      допомогою технічної документації причепа.`
    },
    pressure_in_brake_trailer: {
      title: 'Тиск у магістралі гальмівної системи причепа',
      text: `Значення тиску в гідравлічній системі гальмівного механізму причепа. Визначити його значення можна за
      допомогою технічної документації причепа.`
    },
    load_axles: {
      title: 'Розташування осі (осей), яка (які) постійно сприймає(ють) навантаження',
      text: `Вісь(і) КТЗ, колеса яких знаходяться у постійному контакті з поверхнею дорожнього покриття. Визначити
      їх можна за технічною документацією транспортного засобу.		`
    },
    distance_between_back_and_coupling_device: {
      title: 'Відстань між центром зчіпного пристрою та заднім габаритом КТЗ',
      text: `Відповідна відстань між центром зчіпного пристрою та заднім габаритом, що обчислюється в міліметрах.
      Визначити її можна вимірявши самостійно або з технічної документації транспортного засобу.`
    },
    axis_drive_pneumatic_suspension: {
      title: 'На рушійній(их) осі (осях) застосовано пневматичну підвіску або еквівалентні пристрої',
      text: `Пневматична підвіска - це різновид підвіски, за допомогою якої є можливість регулювання кліренсу.
       Визначити наявність такої підвіски можна визначити за допомогою органолептичного контролю або технічної
        документації транспортного засобу.`
    },
    length: {
      title: 'Довжина',
      text: `Максимальна довжина зовнішнього габариту транспортного засобу. Відстань можна дізнатись з технічної
      документації транспортного засобу або виміряти самостійно.`
    },
    width: {
      title: 'Ширина',
      text: `Максимальна ширина зовнішнього габариту транспортного засобу. Відстань можна дізнатись з технічної
      документації транспортного засобу або виміряти самостійно.`
    },
    height: {
      title: 'Висота',
      text: `Висота транспортного засобу від поверхні дороги до найвищої точки кузова. Відстань можна дізнатись з
      технічної документації транспортного засобу або виміряти самостійно.`
    },
    axis_track: {
      title: 'Колія осі',
      text: `Це відстань між двома колесами на одній осі в центрі точки дотику колії. Відстань можна дізнатись з
      технічної документації транспортного засобу або виміряти самостійно.`
    },
    posterior_overhang: {
      title: 'Задній звис',
      text: `Це відстані від осі коліс до задньої точки автомобіля. Визначити її можна з технічної документації
      транспортного засобу або виміряти самостійно.`
    },

    distance_between_front_and_coupling_device: {
      title: 'Відстань між переднім габаритом КТЗ та центром зчіпного пристрою',
      text: `Відповідна відстань між центром зчіпного пристрою та передним габаритом, що обчислюється в міліметрах.
      Визначити її можна вимірявши самостійно або з технічної документації транспортного засобу.`
    },
    displacement_saddle_coupling_device_min: {
      title: 'Зміщення сідельно-зчіпного пристрою відносно заднього мосту, мін',
      text: `Мінімальна довжина ходу сідельно-зчіпного пристрою відносно заднього мосту, необхідна для індивідуального
      регулювання сукупної довжини автопоїзда та оптимального розподілу навантаження між осями. Її можна визначити у
      технічній документації автомобіля-тягача.`
    },
    displacement_saddle_coupling_device_max: {
      title: 'Зміщення сідельно-зчіпного пристрою відносно заднього мосту, макс',
      text: `Максимальна довжина ходу сідельно-зчіпного пристрою відносно заднього мосту, необхідна для індивідуального
       регулювання сукупної довжини автопоїзда та оптимального розподілу навантаження між осями. Її можна визначити
        у технічній документації автомобіля-тягача.`
    },
    weight: {
      title: 'Маса КТЗ у спорядженому стані',
      text: `Це маса транспортного засобу, яка враховує вагу стандартного обладнання (запасного колеса, інструментів),
      масу усіх експлуатаційних матеріалів (палива, рідини, що охолоджує, масла і т. д.), але не враховує масу вантажу,
      водія і пасажирів. Виміряти можна лабораторним методом або дізнатись з технічної документації транспортного засобу.`
    },
    gross_weight: {
      title: 'Максимальна технічно припустима повна маса',
      text: `Це маса спорядженого та гранично навантаженого транспортного засобу, передбачена розробником. Визначити її
      можна із технічної документації транспортного засобу.`
    },
    max_combine_weight: {
      title: 'Технічно припустима максимальна маса комбінації',
      text: `Це сума максимальної маси транспортного засобу разом з гранично навантаженим причепом або напівпричепом,
      якщо транспортний засіб може бути використано для їхнього буксирування. Визначити її можна із технічної
      документації транспортного засобу.`
    },
    coupling_device_static_weight: {
      title: 'Технічно припустима максимальна статична маса, що припадає на зчіпний пристрій',
      text: `Вертикальне статичне навантаження у центрі кульового шарніра зчіпного пристрою при будь-якому ваговому
      стані причепа.`
    },
    trailer_max_weight_with_brakes: {
      title: 'Максимальна маса причепа за наявності робочої системи гальмування',
      text: `Максимальна маса причепу визначається по відношенню до автомобіля тягача. Визначити масу можна в технічній
       документації транспортного засобу.`
    },
    trailer_max_weight_without_brakes: {
      title: 'Максимальна маса причепа за відсутності робочої системи гальмування',
      text: `Маса, що не повинна перевищувати максимально допустиму масу, встановлену виробником тягача, тобто повну
       масу тягача.`
    },
    coupling_device_weight: {
      title: 'Вага ТЗП',
      text: `Вага усіх складових пристрою для приєднання причепів/напівпричепів до транспортного засобу. Визначити її
      можна із технічної документації тягово-зчіпного пристрою(ТЗП).`
    },
    coupling_device_max_weight: {
      title: 'Допустима максимальна маса буксируючого причепа',
      text: `Це максимальна маса причепа, що буксирується автомобілем. Визначити її можна із технічної документації
      транспортного засобу.`
    },
    is_international_permissible_weight: {
      title: 'Вибір правила для припустимих мас',
      text: `Виберіть для якого рівня правового поля буде застосована регуляція допустимих мас транспортного засобу.`
    },
    is_registration_permissible_weight: {
      title: 'Вибір Реєстраційна/експлуатаційна для припустимої маси',
      text: `Виберіть, який вид маси підлягає огляду:<br><br>
      	- реєстраційна припустима маса –– визначена при державній реєстрації маса транспортного засобу, що не може
      	 перевищувати його максимальну, тобто повну масу, що вказана в реєстраційних документах заводом-виробником;<br>
		- експлуатаційна припустима маса –– визначена в окремому порядку маса причепа, яка може бути дозволена для
		експлуатації в окремій країні.`
    },
    permissible_weight: {
      title: 'Реєстраційна/експлуатаційна максимально припустима повна маса',
      text: `Вкажіть значення відповідно реєстраційної або експлуатаційної максимально припустимої повної маси.
      Визначити її можна в технічній документації причепу.`
    },
    is_registration_max_combine_weight_legal: {
      title: 'Вибір Реєстраційна/ експлуатаційна для макс. припустимої маси комбінації КТЗ',
      text: `Виберіть, який вид маси підлягає огляду:<br><br>
      	- реєстраційна припусти маса –– визначена при державній реєстрації маса транспортного засобу, що не може
      	 перевищувати його максимальну, тобто повну масу, що вказана в реєстраційних документах заводом-виробником;<br>
		- експлуатаційна маса –– визначена в окремому порядку маса причепу, яка може бути дозволена для експлуатації в
		окремій країні.`
    },
    max_combine_weight_legal: {
      title: 'Реєстраційна/експлуатаційна максимально припустима маса комбінації КТЗ',
      text: `Вкажіть значення відповідно реєстраційної або експлуатаційної максимально припустимої повної маси.`
    },
    transmission_type: {
      title: 'Тип трансмісії',
      text: `Трансмісія (або коробка передач) - сукупність систем автомобіля, які передають імпульс від двигуна до коліс.
       Інформацію стосовно типу трансмісії транспортного засобу можна переглянути за допомогою VIN-коду, у технічному
        паспорті транспортного засобу або технічних документах до транспортного засобу.`
    },
    engine_location: {
      title: 'Розташування двигуна',
      text: `Розташування агрегата по відношенню до інших систем конструкції транспортного засобу. Визначити
       розташування можна з технічної документації транспортного засобу або органолептичним контролем(візуальним
        оглядом та на дотик).`
    },
    engine_pollution_reduction: {
      title: 'Система зниження забруднення двигуна',
      text: `Це система, що знижує токсичність відпрацьованих газів у відповідності з міжнародними стандартами.
      Визначити її можна з технічної документації транспортного засобу.`
    },
    engine_cooling_system: {
      title: 'Система охолодження двигуна',
      text: `Це система, що слугує для підтримання робочої температури двигуна шляхом примусового відведення тепла
       від циліндрів двигуна і передачі його навколишньому повітрю. Визначити її можна з технічної документації
       транспортного засобу.`
    },
    engine_euro_rate: {
      title: 'Євро норма',
      text: `Євро-норми (класи токсичності) встановлюють граничні значення для викиду шкідливих речовин нових
       автомобілів. Визначити його можна за допомогою документації транспортного засобу завода-виробника, сертифіката
        відповідності рівню екологічних вимог, маркуванню на транспортному засобі.`
    },
    engine_manufacturer: {
      title: 'Виробник двигуна',
      text: `Завод-виробник двигуна транспортного засобу. Дізнатись виробника можна з описової частини VIN-коду або
       технічної документації транспортного засобу.`
    },
    engine_code: {
      title: 'Код двигуна',
      text: `Унікальний ідентифікаційний номер двигуна транспортного засобу. Знайти його можна в описовій частині
       VIN-коду, на корпусі двигуна або в технічній документації транспортного засобу.`
    },
    engine_working_principle: {
      title: 'Робочий принцип',
      text: `Визначає в який спосіб пальне потрапить у двигун внутрішнього згоряння. Дізнатись його можна з
      технічної документації транспортного засобу.`
    },
    cylinder_arrangement: {
      title: 'Розташування циліндрів',
      text: `Особливості положення циліндрів у конструкції двигуна. Визначити розташування можна з технічної
      документації транспортного засобу або органолептичним контролем (візуальним оглядом та на дотик).`
    },
    count_cylinders: {
      title: 'Кількість циліндрів',
      text: `Кількість циліндрів двигуна автомобіля. Визначити розташування можна з технічної документації
      транспортного засобу.`
    },
    engine_capacity: {
      title: 'Робочий об\'єм',
      text: `Це характеристика двигуна внутрішнього згоряння, що складається з робочих об'ємів усіх циліндрів.
      Робочий обʼєм двигуна можна визначити у описовій частині VIN-коду або технічній документаціі транспортного засобу.`
    },
    fuel_type: {
      title: 'Тип палива',
      text: `Потрібно вказати, яким паливом заправляється транспортний засіб. Даний вид палива можливо дізнатись у
      свідоцтві про реєстрацію транспортного засобу або в технічній документації КТЗ.`
    },
    distance_between_balloon_and_road: {
      title: 'Дистанція між балоном та дорогою',
      text: `Вказати відстань від газового балону, що встановнений або закріплений на КТЗ і поверхнею дороги.
       Дізнатись її можна з технічної документації транспортного засобу або за результатами вимірювань із застосуванням
        засобів вимірювальної техніки.`
    },
    engine_power: {
      title: 'Максимальна потужність',
      text: `Максимальна потужність двигуна виражає відношення роботи механізму до часового інтервалу її здійснення.
      Дізнатись її можна з технічної документації транспортного засобу.`
    },
    engine_rpm: {
      title: 'Обертаючий момент',
      text: `Характеризує силу, з якою обертатиметься коленвал, і наскільки успішно він долатиме опір обертанню.
      Визначити його можна з технічної документації транспортного засобу.`
    },
    max_speed: {
      title: 'Максимальна швидкість',
      text: `Найбільша швидкість, яку може розвинути транспортний засіб на максимальних обертах двигуна. Визначити її
      можна з технічної документації транспортного засобу.`
    },
    total_angular_distance: {
      title: 'Сумарний кутовий проміжок рульового керування',
      text: `Сумарний кут, на який повертається рульове колесо під дією нормативного зусилля, що діє у протилежних
      напрямках, за умови відсутності повороту керованих коліс КТЗ. Визначити його можна з технічної документації
      транспортного засобу.`
    },
    engine_boost: {
      title: 'Наддув двигуна',
      text: `Це збільшення подачі повітря в циліндри для форсування роботи двигуна. Наявність або відсутність даної
      властивості можна визначити у технічній документації транспортного засобу.`
    },
    ratio_engine_power_to_weight: {
      title: 'Відношення максимальної потужності до маси КТЗ у спорядженому стані',
      text: `Це відношення максимальної потужності силової установки на одиницю маси колісного засобу за максимального
        завантаження. Визначається технічною документацію транспортного засоба.<br>
        Маса КТЗ у спорядженому стані визначають як власну масу, до якої додають:<br>
        - масу палива за умови заповнення щонайменше на 90 %;<br>
        - масу додаткового обладнання, яким зазвичай виробник комплектує КТЗ:
         повний набір інструменту, засоби для утримування багажу, вітрове скло, захисні пристрої тощо.<br><br>

        Для визначення маси у спорядженому стані у разі КТЗ, які використовують для живлення двигуна суміш палива та
        мастила, враховують таке:<br>
        а) якщо конструкція системи живлення передбачає попереднє змішування палива з мастилом, то за масу палива
        приймають масу суміші;<br>
        б) якщо конструкція системи живлення передбачає змішування палива з мастилом в процесі роботи двигуна, то за
        масу палива приймають тільки власну масу палива, а масу мастила враховують під час визначання власної маси.`
    },
    transferable_number: {
      title: 'Передатні числа',
      text: `Це відношення числа зубів веденої шестерні до числа зубів ведучої (КПП або редуктора). Визначити їх можна
       з технічної документації транспортного засобу.`
    },
    count_controlled_axles: {
      title: 'Управлійні осі кількість',
      text: `Вказати кількість управлійних осей КТЗ. Визначити їх можна за технічною документацією транспортного засобу.`
    },
    code_uktzed: {
      title: 'Код УКТЗЕД',
      text: `Код класифікації товарів для цілей митного оформлення, що здійснюється згідно з вимогами Української
        класифікації товарів зовнішньоекономічної діяльності (УКТЗЕД). Код призначається автоматично при виборі типу
        транспортного засобу, згідно з Законом <a href="https://zakon.rada.gov.ua/laws/show/584%D0%B1-18#n3"
         target="_blank">«Про митний тариф України»</a>.`,
    },
    weight_distribution: {
      title: 'Технічно припустима маса',
      text: `Маса навантаження від маси КТЗ, що передається на дорожню поверхню колесами групи осей та визначається
       заводом виробником при реєстрації КТЗ. Визначити її можна з технічної документації ТЗ.`
    },
    distance_between_axes: {
      title: 'Відстань до наступної осі',
      text: `Довжина між даною віссю та наступною. Відстань можна дізнатись з технічної документації транспортного
      засобу або виміряти самостійно.`
    },
    tire_width: {
      title: 'Ширина шини',
      text: `Це відстань від однієї боковини протектора до іншої. Цей показник вказується як перші цифри під час
      маркування тієї чи іншої моделі шини.`
    },
    tire_height: {
      title: 'Висота шини',
      text: `Це профіль шини, який відображається в відсотковому відношенні до ширини. Цей показник вказується як другі
      цифри під час маркування тієї чи іншої моделі шини.`
    },
    diameter: {
      title: 'Діаметр диска',
      text: `Це внутрішній діаметр шини, що відповідає посадковому діаметру. Цей показник вказується як останні цифри
       під час маркування тієї чи іншої моделі шини.`
    },
    tire_tread_height: {
      title: 'Висота малюнку протектора шини',
      text: `Це відстань від дна борозенки для води до крайньої верхньої точки підошви, що контактує з дорогою.
      Виміряти його можна за допомогою штангенциркуля або спеціальної лінійки із глибиноміром.`
    },
    pressure: {
      title: 'Тиск',
      text: `Це кількість повітря в шинах, яка вимірюється в кілограмах на сантиметр квадратний. Виміряти можна за
      допомогою манометра.`
    },
    is_registration_axis_permissible_weight: {
      title: 'Вибір Реєстраційна/експлуатаційна для припустимої маси на осі',
      text: `Виберіть, який вид маси підлягає огляду:<br>
        - реєстраційна маса –– визначена при державній реєстрації маса причепа, що не може перевищувати його
        максимальну, тобто повну масу, що вказана в реєстраційних документах заводом-виробником;<br>
        - експлуатаційна маса –– визначена в окремому порядку маса причепа, яка може бути дозволена для експлуатації
        в окремій країні.`
    },
    axis_permissible_weight: {
      title: 'Реєстраційна/експлуатаційна максимально припустима маса на осі',
      text: `Вкажіть значення відповідно реєстраційної або експлуатаційної максимально припустимої маси на осі.
      Визначити її можна в технічній документації транспортного засобу.`
    },
    is_registration_group_max_weight_permissible: {
      title: 'Вибір Реєстраційна/експлуатаційна для припустимої маси на групі осей',
        text: `Виберіть, який вид маси підлягає огляду: <br>
    - реєстраційна припустима маса –– визначена при державній реєстрації маса транспортного засобу, що не може
    перевищувати його максимальну, тобто повну масу, що вказана в реєстраційних документах заводом-виробником для
     кожної групи вісей;<br>
    - експлуатаційна маса –– визначена в окремому порядку маса транспортного засобу для кожної групи вісей, яка може
     бути дозволена для експлуатації в окремій країні.`
    },
    groupCount: {
      title: 'Кількість груп осей',
      text: `Це згруповані осі, конструктивно об'єднані та (або) не об'єднані у візок, з відстанню між найближчими
      осями до 2,5 метра (включно). Визначити їх можна органолептичним контролем(органами зору та на дотик) або з
      технічної документації транспортного засобу.`
    },
    count_axis_in_group: {
      title: 'Кількість осей в групі',
      text: `Визначити кількість осей в групі можна за допомогою органолептичного контролю(візуальним оглядом та на
      дотик), або з технічної документаціх КТЗ.`
    },
    group_weight_distribution: {
      title: 'Технічно припустима маса на кожній групі осей',
      text: `Маса навантаження від маси КТЗ, що передається на дорожню поверхню колесами групи осей та визначається
      заводом виробником при реєстрації КТЗ. Визначити її можна з технічної документації ТЗ.`
    },
    group_max_weight_permissible: {
      title: 'Реєстраційна/експлуатаційна максимально припустима маса на кожній групі осей',
      text: `Вкажіть значення відповідно реєстраційної або експлуатаційної максимально припустимої маси для кожної
       групи осей.`
    },
    serial_number: {
      title: 'Маркування',
      text: `Вказати маркування на склі вікна відповідно:<br>
        - американським стандартам безпеки M, AS, DOT;<br>
        - європейському стандарту безпеки ECE R43.<br><br>
        Позначити знаки у форматі:<br>E2, DOT-459, 43R-0001298 або E17, 43R-00346, DOT-503.`
    },
    window_type: {
      title: 'Тип вікна',
      text: `Вказати місце розташування вікна в конструкції транспортного засобу.`
    },
    serial_number_belt: {
      title: 'Маркування',
      text: `Вказати маркування на кожному ремені безпеки, позначивши стандарти, відповідно до яких надавалась
      сертифікація. Наприклад, E1 05 40257, або E13 040718.`
    },
    equippedWeightDistribution: {
      title: 'Розподіл цієї маси за осями',
      text: `Допустима маса навантаження на вісь повністю загруженого автомобіля. Визначити масу можна з технічної
      документації транспортного засобу.`
    }
  }
}
